"use client";

import { c as _c } from "react/compiler-runtime";
import { SuggestionForm } from "@/components/suggestions/SuggestionForm";
import { CONTACT_EMAIL } from "@/lib/site";
import { useLocale, useT } from "@/lib/use-i18n";
// 2026-10-09 bundle-budget: SSOT `locales` (sin diccionarios), no el index
// `@/lib/i18n` — este index construye las 14 locales fusionadas y pesaba ~3 MB
// en el chunk de /suggestions.
import { localePath } from "@/lib/i18n/locales";
import Link from "next/link";
export function SuggestionsContent() {
  const $ = _c(64);
  const t = useT();
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("suggestionsKicker");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="section-kicker mb-4">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("suggestionsPageTitle");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("suggestionsPageTitleItalic");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span className="font-normal text-foreground-soft">{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <h1 className="text-display text-foreground">{t2}{" "}{t4}</h1>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("suggestionsPageBody");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <p className="mt-5 text-base leading-relaxed text-foreground-soft sm:text-[17px]">{t6}</p>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("suggestionsPagePromise");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <p className="mt-4 text-base leading-relaxed text-foreground-soft sm:text-[17px]">{t8}</p>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("suggestionsAlsoSupport");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <p className="mb-2 block text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{t10}</p>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("suggestionsAlsoSupportBody");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== locale) {
    t13 = localePath(locale, "/contact");
    $[27] = locale;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("contactSupport");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <Link href={t13} className="link-underline text-foreground font-medium">{t14}</Link>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <a href={`mailto:${CONTACT_EMAIL}`} className="link-underline font-mono text-foreground font-medium break-all">{CONTACT_EMAIL}</a>;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t12 || $[36] !== t15) {
    t17 = <p className="text-[14px] sm:text-[15px] text-muted-foreground leading-relaxed">{t12}{" "}{t15}{" \xB7 "}{t16}</p>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t11 || $[39] !== t17) {
    t18 = <div className="lovable-card hardware-surface rounded-[var(--radius-panel)] border border-border/80 shadow-xs mt-8 relative overflow-hidden p-6 sm:p-7">{t11}{t17}</div>;
    $[38] = t11;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t1 || $[42] !== t18 || $[43] !== t5 || $[44] !== t7 || $[45] !== t9) {
    t19 = <div className="lg:col-span-6 flex flex-col justify-center page-enter"><div className="max-w-xl">{t1}{t5}{t7}{t9}{t18}</div></div>;
    $[41] = t1;
    $[42] = t18;
    $[43] = t5;
    $[44] = t7;
    $[45] = t9;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t) {
    t20 = t("suggestionsFormTitle");
    $[47] = t;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20) {
    t21 = <p className="mb-2 block text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{t20}</p>;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t) {
    t22 = t("suggestionsFormSubtitle");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t22) {
    t23 = <h2 className="text-xl sm:text-2xl font-bold text-foreground tracking-tight">{t22}</h2>;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t21 || $[56] !== t23) {
    t24 = <div className="mb-6">{t21}{t23}</div>;
    $[55] = t21;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SuggestionForm />;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t24) {
    t26 = <div className="lg:col-span-6 page-enter"><div className="lovable-card hardware-surface rounded-[var(--radius-panel)] border border-border/80 shadow-xs p-6 sm:p-8">{t24}{t25}</div></div>;
    $[59] = t24;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t19 || $[62] !== t26) {
    t27 = <>{t19}{t26}</>;
    $[61] = t19;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  return t27;
}